import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { naturalGasRouteDefinitions } from './NaturalGasRouteDefinitions';

import { generatePageWithTabsRoute } from '../routeGenerator';

const NaturalGasRoutes: RouteObject = generatePageWithTabsRoute(
  'Explore natural gas usage and trends',
  BASE.INTERVAL_DATA_NATURAL_GAS,
  NESTED_ROUTES.INTERVAL_DATA_NATURAL_GAS.USAGE,
  naturalGasRouteDefinitions,
);

export default NaturalGasRoutes;
